import { inject } from '@angular/core';
import { isInsideEditor } from '@dotcms/client';

import { DotCmsFacade } from '../facades/dot-cms.facade';
import { DotCmsService } from '../services/dot-cms/dot-cms.service';

export function dotCmsUvePathProtectionGuard() {
  const dotcmsService = inject(DotCmsService);
  const dotcmsFacade = inject(DotCmsFacade);

  if (!isInsideEditor()) return true;

  const isRouteAllowed = dotcmsService.isUvePathAllowed;
  dotcmsService.isUvePathAllowed = false;
  if (!isRouteAllowed) {
    dotcmsFacade.emitUveNavUrl();
  }

  return isRouteAllowed;
}
